var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "login-bg" }, [
      _c(
        "div",
        {
          staticClass: "col-sm-12 w-login-body",
          class: { row: _vm.$mq !== "sm" },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isDebug,
                  expression: "isDebug",
                },
              ],
              staticClass: "col-sm-6",
            },
            [
              _c("login", {
                staticClass: "w-login-cnt",
                attrs: { "is-login-with-email": true },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: {
                "col-sm-6": _vm.isDebug,
                "col-sm-6 col-sm-offset-3": !_vm.isDebug,
              },
            },
            [_c("external-login", { staticClass: "w-login-cnt" })],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }